import React from 'react';

import { createStyles, Paper, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useLocalization } from 'context/localization-context';

interface ICreditValueCardProps {
  creditValue: number;
}

const useStyles = createStyles(theme => ({
  labelGrid: {
    display: 'grid',
    rowGap: theme.spacing.xs,
    columnGap: theme.spacing.md,
    alignItems: 'center',
    gridTemplateColumns: 'min-content auto',
    gridTemplateRows: 'auto',
    whiteSpace: 'nowrap',
    [theme.fn.smallerThan('sm')]: {
      fontSize: theme.fontSizes.sm,
    },
  },
}));

const CreditValueCard = ({ creditValue }: ICreditValueCardProps): JSX.Element => {
  const { classes, theme } = useStyles();
  const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.sm}`, false);
  const { formatCurrency, isTaxInclusive } = useLocalization();

  return (
    <Paper px='lg' py='md' shadow='xs' radius='md' withBorder>
      <Text size={isDesktop ? 'lg' : 'md'} fw='bold' mb='xs'>
        Credit Value
      </Text>
      <div className={classes.labelGrid}>
        <Text color='dimmed' fs='italic' fz='sm' ta='right'>
          Session Value
        </Text>
        <Text ta='left'>
          {formatCurrency(creditValue / 100)}
          {isTaxInclusive && ' (ex. VAT)'}
        </Text>
      </div>
    </Paper>
  );
};

export default CreditValueCard;
